const STORAGE_KEY_SEPARATOR = '::';
const buildStorageKey = (namespace, key) => `seen${STORAGE_KEY_SEPARATOR}${namespace}${STORAGE_KEY_SEPARATOR}${key}`;
const getLocalStorage = () => {
    try {
        if (typeof window === 'undefined')
            return null;
        return window.localStorage;
    }
    catch {
        return null;
    }
};
export const createLocalStorageSeenIndicator = (storage = getLocalStorage()) => {
    const listeners = new Set();
    let version = 0;
    const notify = () => {
        version += 1;
        listeners.forEach(listener => listener());
    };
    const getSeenSignature = (namespace, key) => {
        if (!storage)
            return null;
        try {
            return storage.getItem(buildStorageKey(namespace, key));
        }
        catch {
            return null;
        }
    };
    return {
        getSeenSignature,
        markSignatureSeen(namespace, key, signature) {
            if (!storage)
                return;
            try {
                const existing = storage.getItem(buildStorageKey(namespace, key));
                if (existing === signature)
                    return;
                storage.setItem(buildStorageKey(namespace, key), signature);
                notify();
            }
            catch {
                // Swallow quota / access errors — seen-state is best-effort.
            }
        },
        hasSeenSignature(namespace, key, signature) {
            return getSeenSignature(namespace, key) === signature;
        },
        subscribe(listener) {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
        getVersion() {
            return version;
        },
    };
};
export const seenIndicator = createLocalStorageSeenIndicator();
//# sourceMappingURL=seenIndicator.js.map